module.exports = __webpack_public_path__ + "img/colors.1f5e8911.png";